"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableToolbar = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTableToolbar = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin: ${({ theme }) => theme.spacing(2.5, 1.5, 1, 1.5)};
`;
